import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

const bands = [
  { top: "18%", left: "-10%", w: "70%", h: "26%", x: [0, 220], o: 0.85, cls: "mist-drift-a" },
  { top: "46%", left: "30%", w: "80%", h: "30%", x: [0, -260], o: 0.75, cls: "mist-drift-b" },
  { top: "68%", left: "-20%", w: "90%", h: "28%", x: [0, 180], o: 0.9, cls: "mist-drift-a" },
];

const MistBand = ({ band, progress, still }) => {
  const x = useTransform(progress, [0, 800], band.x);
  return (
    <motion.div
      style={{ x: still ? 0 : x, top: band.top, left: band.left, width: band.w, height: band.h, opacity: band.o }}
      className={`absolute rounded-[50%] bg-[radial-gradient(ellipse_at_center,rgba(247,249,247,0.95)_0%,rgba(247,249,247,0.55)_40%,rgba(247,249,247,0)_70%)] blur-2xl ${still ? "" : band.cls}`}
    />
  );
};

export const MistLayer = () => {
  const { scrollY } = useScroll();
  const still = useReducedMotion();
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true" data-testid="mist-layer">
      {bands.map((band, i) => (
        <MistBand key={i} band={band} progress={scrollY} still={still} />
      ))}
    </div>
  );
};
